import { HaNDebugPanel } from "./HaNDebugPanel";
import { HaNPage } from "./HaNPage";

type HaNCompound = typeof HaNPage & {
  Page: typeof HaNPage;
  DebugPanel: typeof HaNDebugPanel;
};

export const HaN: HaNCompound = Object.assign(HaNPage, {
  Page: HaNPage,
  DebugPanel: HaNDebugPanel,
});
